import { CdkCopyToClipboard } from '@angular/cdk/clipboard';

import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  inject,
  output,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import {
  SiaComponentConfigPerspectives,
  SiaComponentConfigService,
  SiaI18nDirective,
  SiaI18nService,
  SiaNewRouterService,
  SiaSessionService,
  SiaTranslatePipe,
  notify,
} from '@sia/shared';
import {
  DxButtonModule,
  DxSelectBoxModule,
  DxTextBoxModule,
} from 'devextreme-angular';
import { DxTemplateModule } from 'devextreme-angular/core';
import { EditPerspectiveDialogComponent } from '../../dialogs/edit-perspective-dialog';
import { NewPerspectiveDialogComponent } from '../../dialogs/new-grid-perspective-dialog';
import { GridConfig } from '../../interfaces/grid-config';
import { GridConfigService } from '../../services/grid-config.service';
import { SiaGridConfigTab } from '../sia-grid-config-tab/sia-grid-config-tab.component';
@Component({
  selector: 'sia-grid-config-setup',
  templateUrl: './sia-grid-config-setup.component.html',
  styleUrls: ['./sia-grid-config-setup.component.scss'],
  standalone: true,
  imports: [
    SiaI18nDirective,
    MatButton,
    DxSelectBoxModule,
    DxButtonModule,
    DxTemplateModule,
    DxTextBoxModule,
    CdkCopyToClipboard,
    SiaTranslatePipe,
  ],
})
export class SiaGridConfigSetupComponent
  extends SiaGridConfigTab
  implements OnDestroy, OnInit
{
  private sessionService = inject(SiaSessionService);
  private i18nService = inject(SiaI18nService);
  private configService = inject(GridConfigService);
  private componentConfigService = inject(SiaComponentConfigService);
  private routerService = inject(SiaNewRouterService);
  dialog = inject(MatDialog);

  //#endregion
  perspectiveSelected = output<SiaComponentConfigPerspectives>();
  //#endregion
  viewConfiguration = output();
  //#endregion
  cloneConfiguration = output<any>();
  private _perspective: SiaComponentConfigPerspectives = {};
  private _gridId: string = '';
  confAvailable: string = '';
  existingConfigurations: SiaComponentConfigPerspectives[] = [];
  cloneConf: SiaComponentConfigPerspectives = {};
  cloneFromExistent: boolean = false;
  confLoaded: boolean = false;
  gridPerspectives: SiaComponentConfigPerspectives[] = [];
  opDescription: string = '';
  exportPopupVisible: boolean = false;

  @HostListener('window:unload')
  ngOnDestroy() {
    this._perspective = {};
    this._gridId = '';
    this.cloneConf = {};
    this.gridPerspectives = [];
    this.opDescription = '';
    this.confAvailable = '';
    this.confLoaded = false;
    super.ngOnDestroy();
  }

  get gridId() {
    return this._gridId;
  }

  get deviceTypeConf() {
    return this._perspective;
  }

  set deviceTypeConf(value: SiaComponentConfigPerspectives) {
    this._perspective = value;
    if (!value) return;
    this.loadConfig();
    this.confLoaded = true;
  }

  //#region private methods
  private loadConfig() {
    if (this.cloneConf) {
      this.perspectiveSelected.emit(this._perspective);
    }
  }

  //#endregion

  //#region public methods
  sqlEdit() {
    this.routerService.navigateToSqlEditor(this.gridId);
  }
  cloneConfigClick() {
    var ev = {
      perspectiveId: this._perspective.id,
      cloneFrom: this.cloneConf.id,
    };
    this.cloneConfiguration.emit(ev);
  }

  viewConfigClick() {
    this.viewConfiguration.emit();
  }

  createPerspective() {
    const dialogRef = this.dialog.open(NewPerspectiveDialogComponent, {
      width: '500px',
      data: {},
    });

    let s0 = dialogRef.afterClosed().subscribe((result) => {
      if (!result) return;
      let newPerspective: SiaComponentConfigPerspectives = {
        componentId: this._gridId,
        configType: 'grid',
        description: result.name,
      };
      this.configService
        .getGridDefaultConfiguration(result.reference, this._gridId)
        .then((data: GridConfig) => {
          if (!data) return;
          newPerspective.jsonConfig = JSON.stringify(data);
          this.deviceTypeConf = newPerspective;
          this.gridPerspectives.push(newPerspective);
        });
    });
    this._subs.push(s0);
  }
  cloneReady() {
    if (
      this.cloneConf &&
      this.cloneConf.componentId &&
      this.cloneConf.componentId.length > 0
    ) {
      this.opDescription =
        'Per ' +
        this.gridId +
        ' verrà usata la configurazione di ' +
        this.cloneConf.componentId;
      return true;
    }
    return false;
  }

  editPerspective() {
    const dialogRef = this.dialog.open(EditPerspectiveDialogComponent, {
      width: '500px',
      data: this._perspective,
    });
    let s0 = dialogRef.afterClosed().subscribe((res) => {
      this._perspective = res;
      this.confLoaded = false;
      this.loadComponentPerspectivesInfo();
    });
    this._subs.push(s0);
  }

  ngOnInit(): void {
    super.ngOnInit();
    // this.sessionService.hideParams$();
    let g = this.routerService.getLatestRoutingData()?.guid;
    if (g) {
      var pv = this.sessionService.getSessionParamValue('gridId');
      if (!pv) {
        this._gridId = '';
      } else {
        this._gridId = pv;
      }
    } else {
      this._gridId = '';
    }
    this.loadComponentPerspectivesInfo();
    this.loadGridsPerspectives();
  }

  private loadComponentPerspectivesInfo() {
    this.confAvailable = '';
    this.componentConfigService
      .getComponentPerspectives('grid', this._gridId)
      .then((data: SiaComponentConfigPerspectives[] | null) => {
        if (!data || data.length == 0) return;
        this.gridPerspectives = data;
        let firstloop: boolean = true;
        data.forEach((element) => {
          if (firstloop) {
            firstloop = false;
          } else this.confAvailable += ', ';
          this.confAvailable += element.description;
        });
      });
  }

  openExportPopup() {
    this.exportPopupVisible = true;
  }
  loadGridsPerspectives() {
    if (this.existingConfigurations && this.existingConfigurations.length > 0)
      return;
    this.componentConfigService.getPerspectivesInfo('grid').then((data) => {
      if (data) {
        this.existingConfigurations = data;
        this.existingConfigurations.map((x: any) => {
          x['fullDescription'] = x.componentId + ' - ' + x.description;
        });
      }
    });
  }
  getDataDescription(data: any) {
    if (!data) return '';
    return data.fullDescription;
  }
  localSaveGridConfigFile() {
    let a = document.createElement('a');
    let file = new Blob([this.gridConfigJson], { type: 'text/plain' });
    a.href = URL.createObjectURL(file);
    a.download = this.gridId + '_' + this._perspective + '.json';
    a.click();
  }

  remoteSaveGridConfigFile() {
    let file = new Blob([this.gridConfigJson], { type: 'text/plain' });
    let fileToUpload = <File>file;
    let name = this.gridId + '_' + this._perspective + '.json';
    const formData = new FormData();
    formData.append('file', fileToUpload, name);
    this.configService
      .remoteSaveGridConfigurationFile(formData)
      .then((res) => {
        if (res) {
          notify('Configurazione salvata correttamente', 2000, 'success');
        } else {
          notify(
            'Impossibile salvare configurazione, riprova',
            2000,
            'warning',
          );
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }
  //#endregion
}
